/** Types of impersonation that can occur */
export const IMPERSONATION_TYPES = {
  MITER_ADMIN: "miter_admin",
  CUSTOMER_SUPER_ADMIN: "customer_super_admin",
} as const;
export type ImpersonationType = (typeof IMPERSONATION_TYPES)[keyof typeof IMPERSONATION_TYPES];
export const ImpersonationTypeValues = Object.values(IMPERSONATION_TYPES);

/** Account types that can be associated with an impersonator */
export type ImpersonatorAccountType = "team_member" | "role";

/**
 * Identity information about the person who initiated an impersonation.
 * Used in both JWT storage and logging.
 */
export type ImpersonatorIdentity = {
  /** The user ID of the impersonator */
  user_id: string;
  /** The account ID (role_id or team_member_id) */
  account_id?: string;
  /** The type of account (team_member or role) */
  account_type?: ImpersonatorAccountType;
  /** Email for debugging/display */
  email?: string | null;
  /** Phone number for debugging/display */
  phone?: string | null;
  /** First name for display/logging */
  first_name?: string | null;
  /** Last name for display/logging */
  last_name?: string | null;
};

/**
 * Context stored in the JWT when someone is impersonating another user.
 * Contains information about who initiated the impersonation.
 */
export type ImpersonationMetadata = {
  /** The type of impersonation being performed */
  type: ImpersonationType;
  /** Information about who initiated the impersonation */
  impersonator: ImpersonatorIdentity;
  /** Unix timestamp when impersonation started */
  started_at: number;
};
